module.exports = __webpack_public_path__ + "img/reasons-to-join-us--spread/0R2A2198.jpg";